import React from 'react';
//import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import { connect } from '../../utils';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';

const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(props.id, props.children.length, monitor.getItem());
    }
  }
};
const checkStyles = (size, color) => {
  let  iconS = {
    borderRadius:'50%',
    backgroundColor: color
  };
  if (size === 'large') {
    iconS.width= 120;
    iconS.height = 120;
    iconS.padding = 30;
  } else if (size === 'medium') {
    iconS.width= 96;
    iconS.height = 96;
    iconS.padding = 24;
  }  else if (size === 'small') {
    iconS.width= 72;
    iconS.height = 72;
    iconS.padding = 16;
  }
  return iconS;
}
const checkStylesIcon = (size) => {
  let  iconS = styles.xsmallIcon;
  if (size === 'large') {
    iconS = styles.largeIcon;
  } else if (size === 'medium') {
    iconS = styles.mediumIcon;
  }  else if (size === 'small') {
    iconS = styles.smallIcon;
  }
  return iconS;
}

const EditLayout = ({ id, children, isOverCurrent, connectDropTarget, type, layoutState, readOnly }) => {
  const {values} = layoutState.getItemJS(id).props;
  return connectDropTarget(
    <div style={{
      boxSizing: 'border-box',
      position: 'relative',
      height: 'auto',
      display: 'flex',
      width:'100%',
      justifyContent: values.buttonAlign,
      flex:1,
      padding: values.containerPadding
    }}>
      <IconButton
        disabled={values.disabled}
        iconStyle={checkStylesIcon(values.size)}
        style={checkStyles(values.size, values.buttonColors.backgroundColor)}
        tooltip={values.tooltip}
        tooltipPosition={values.tooltipPosition}
       >
        <FontIcon className="material-icons" color={values.buttonColors.color} hoverColor={values.buttonColors.hoverColor}> {values.icon} </FontIcon>
      </IconButton>
    </div>
  );
};

const styles = {
  xsmallIcon: {
    fontSize: 24,
  },
  smallIcon: {
    width: 36,
    height: 36,
    fontSize: 36,
  },
  mediumIcon: {
    width: 48,
    height: 48,
    fontSize: 48,
  },
  largeIcon: {
    width: 60,
    height: 60,
    fontSize: 60,
  }, 
};

/**
 * note : in here for edit not show the target url for button
 * href={values.href.url}
   target={values.href.target}
 */
const LayoutContainer = DropTarget('IconButtonView', target, (conn, monitor) => ({
  connectDropTarget: conn.dropTarget(),
  isOverCurrent: monitor.isOver({shallow: true})
}))(EditLayout);

export default connect('layoutState', 'readOnly')(LayoutContainer);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDIconButton.js